import { createAsyncThunk } from '@reduxjs/toolkit';
import { Article } from '@wix/answers-api';

import { fedopsLogger } from '../../util/renderModel';
import { getArticleById } from '../api/getArticleById';
import { getArticleByUri } from '../api/getArticleByUri';
import { HttpClientFactory } from '../httpClient';
import { TRootState } from '../reducers';
import { ErrorStatus } from '../reducers/types';

export const loadArticleById = createAsyncThunk<
  Article,
  { id: string; httpClient: HttpClientFactory },
  { state: TRootState; rejectValue: ErrorStatus }
>('loadArticleById', async ({ id, httpClient }, { rejectWithValue, getState }) => {
  try {
    fedopsLogger.interactionStarted('fetching-article');
    const article = await getArticleById(id, httpClient);
    fedopsLogger.interactionEnded('fetching-article');
    return article;
  } catch (error) {
    fedopsLogger.interactionEnded('fetching-article');
    return rejectWithValue(error.response?.status);
  }
});

export const loadArticleByUri = createAsyncThunk<
  Article,
  { uri: string; httpClient: HttpClientFactory },
  { state: TRootState; rejectValue: ErrorStatus }
>('loadArticleByUri', async ({ uri, httpClient }, { rejectWithValue, getState }) => {
  try {
    fedopsLogger.interactionStarted('fetching-article');
    const article = await getArticleByUri(uri, httpClient);
    fedopsLogger.interactionEnded('fetching-article');

    return article;
  } catch (error) {
    fedopsLogger.interactionEnded('fetching-article');
    return rejectWithValue(error.response?.status);
  }
});
